import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Divider,
} from "@mui/material";
import { InputForm } from "components/ui/inputForm";
import { FormProvider, useForm, SubmitHandler } from "react-hook-form";
import PasswordSVG from "assets/images/password.svg";
import { useAuthStore } from "hooks/useAuthStore";

type InputTypes = {
  oldPassword: string;
  newPassword: string;
  newPassword_confirmation: string;
};

export const ModalChangePassword = () => {
  const methods = useForm<InputTypes>();
  const {
    startChangePassword,
    changeOpenModalPassword,
    showModalChangePassword,
  } = useAuthStore();

  const onSubmit: SubmitHandler<InputTypes> = (data) => {
    const newData = {
      ...data,
      _method: "PUT",
    };
    startChangePassword(newData);
    methods.reset();
  };

  return (
    <Dialog
      open={showModalChangePassword}
      onClose={() => {
        changeOpenModalPassword(false);
        methods.reset();
      }}
    >
      <FormProvider {...methods}>
        <form className="w-full" onSubmit={methods.handleSubmit(onSubmit)}>
          <DialogTitle>Cambiar contraseña</DialogTitle>
          <Divider />
          <DialogContent>
            <Grid container spacing={2} className="pt-6">
              <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                <Grid container spacing={2} className="pt-6">
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <InputForm
                      name="oldPassword"
                      label="Contraseña actual"
                      size="small"
                      className="w-full"
                      rules={{
                        required: {
                          value: true,
                          message: "La contraseña actual es un campo requirido",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <InputForm
                      name="newPassword"
                      label="Nueva Contraseña"
                      size="small"
                      className="w-full"
                      rules={{
                        required: {
                          value: true,
                          message: "La nueva contraseña es un campo requirido",
                        },
                        pattern: {
                          value:
                            /^(?=.*[0-9])(?=.*[!@#$&()?.*%+_-])(?=.*[A-Z]).{8,}$/,
                          message:
                            "La contraseña debe incluir almenos 8 caracteres, una letra mayuscula, un número y un caracter especial como: ! @ # $ & ( ) ? . * % + _ -",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <InputForm
                      name="newPassword_confirmation"
                      label="Confirmar contraseña"
                      size="small"
                      className="w-full"
                      rules={{
                        required: {
                          value: true,
                          message: "Confirmar contraseña es un campo requirido",
                        },
                        validate: (val: string) => {
                          if (methods.watch("newPassword") !== val) {
                            return "Las contraseñas no coinciden";
                          }
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                <img src={PasswordSVG} className="h-60" alt="profile" />
              </Grid>
            </Grid>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button
              variant="outlined"
              type="button"
              onClick={() => {
                changeOpenModalPassword(false);
                methods.reset();
              }}
            >
              Cancelar
            </Button>
            <Button variant="outlined" type="submit">
              Guardar
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};
